import {Injectable} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {EMPTY, Observable, of, throwError} from 'rxjs';
import {AuthStore} from "../stores/auth.store";

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    constructor(private authStore: AuthStore) { }

    currentError: HttpErrorResponse | null = null;
    showDetails = false;

    handleError(error: HttpErrorResponse, caught: Observable<any>): Observable<any> {
        // If we get an error, we want to set the initalRequest to false so we can recheck the user's permissions
        this.authStore.initalRequest = false;

        if (error.status === 503) {
            return throwError(error);
        }
        if (error.status === 401) {
            return EMPTY
        }
        if (error) {
            this.currentError = error;
        }
        return throwError(error);
    }

    clearError(): void {
        this.currentError = null;
        this.showDetails = false;
    }

    openDetails(): void {
        this.showDetails = true;
    }

    closeDetails(): void {
        this.showDetails = false;
    }

    handleSuccess(response: any): Observable<any> {
        return of(response);
    }
}
